import type { LinkProps } from "@tanstack/react-router";
import {
	CalendarDaysIcon,
	ClipboardListIcon,
	ClipboardPlusIcon,
	FileTextIcon,
	LayoutDashboardIcon,
	ReceiptIcon,
	StethoscopeIcon,
	UsersIcon,
} from "lucide-react";
import type { NavigationConfig, NavigationModules } from "./types";

export const paths = {
	overview: "/dashboard",
	appointments: "/dashboard/appointments",
	invoices: "/dashboard/invoices",
	doctors: "/dashboard/doctors",
	formularies: "/dashboard/formularies",
	patients: "/dashboard/patients",
	procedures: "/dashboard/procedures",
	proceduresTypes: "/dashboard/procedures/types",
} satisfies Record<NavigationModules, LinkProps["to"]>;

export const navigation: NavigationConfig = {
	groups: [
		{
			title: "dashboard",
			items: [
				{
					module: "overview",
					url: paths.overview,
					icon: LayoutDashboardIcon,
				},
				{
					module: "appointments",
					url: paths.appointments,
					icon: CalendarDaysIcon,
				},
				{
					module: "invoices",
					url: paths.invoices,
					icon: ReceiptIcon,
				},
				// {
				// 	module: "branches",
				// 	url: paths.branches,
				// 	icon: Building2Icon,
				// },
				{
					module: "doctors",
					url: paths.doctors,
					icon: StethoscopeIcon,
				},

				{
					module: "patients",
					url: paths.patients,
					icon: UsersIcon,
				},
				{
					module: "procedures",
					url: paths.procedures,
					icon: ClipboardPlusIcon,
				},
			],
		},
		{
			title: "settings",
			items: [
				{
					module: "formularies",
					url: paths.formularies,
					icon: FileTextIcon,
				},
				{
					module: "proceduresTypes",
					url: paths.proceduresTypes,
					icon: ClipboardListIcon,
				},
			],
		},
	],
};
